import { useNavigate } from "react-router-dom";
import * as compSettings from "./settings";

const NavBar = ({ id, extendedSettings, safeArea }) => {
  const navigate = useNavigate();

  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };
  console.log(settings)
  //TODO:Logo settingsten gelecek

  const logoHeight = settings.logoHeight.value + "px";
  const marginX = settings.marginX.value + "px";
  const marginTop = settings.marginTop.value + "px";
  const marginBottom = settings.marginBottom.value + "px";
  const leftItemPaddingX = settings.leftItemPaddingX.value + "px";
  const leftItemPaddingY = settings.leftItemPaddingY.value + "px";
  const rightItemPaddingX = settings.rightItemPaddingX.value + "px";
  const rightItemPaddingY = settings.rightItemPaddingY.value + "px";
  const borderBottomWidth = settings.borderBottomWidth.value + "px";
  const leftIconSize = settings.leftIconSize.value + "px";
  const rightIconSize = settings.rightIconSize.value + "px";

  const backgroundColor = settings.backgroundColor.value;
  const leftIconColor = settings.leftIconColor.value;
  const rightIconColor = settings.rightIconColor.value;
  const borderBottomColor = settings.borderBottomColor.value;

  const shadow = settings.shadow.value;
  const sticky = settings.sticky.value;

  const showLeftIcon = settings.showLeftIcon.value;
  const showRightIcon = settings.showRightIcon.value;
  const logo = JSON.parse(settings.logo.value)[0].original


  const searchBtnOnClick = () => navigate("/search");
  const logoOnClick = () => navigate("/");
  const notificationOnClick = () => navigate("/notifications");

  const SearchIcon = (
    <svg
      fill={leftIconColor}
      width={leftIconSize}
      height={leftIconSize}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" />
    </svg>
  );

  const BellIcon = (
    <svg
      width={rightIconSize}
      height={rightIconSize}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.48149 9.07777C6.39886 5.86945 8.89127 3 12.1007 3V3C15.24 3 17.656 5.74275 17.5341 8.87969C17.5127 9.42969 17.5 9.97677 17.5 10.5C17.5 13.7812 21 18 21 18H3C3 18 6.5 14.7188 6.5 10.5C6.5 10.0122 6.49331 9.5369 6.48149 9.07777Z"
        stroke="#333333"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 21C10.4886 21.6132 11.2035 22 12 22C12.7965 22 13.5114 21.6132 14 21"
        stroke={rightIconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div
      style={{
        position: sticky ? "sticky" : "static",
        top: sticky ? 0 : "auto",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        paddingTop: Number(safeArea?.top) + "px",

        marginLeft: marginX,
        marginRight: marginX,
        marginTop: marginTop,
        marginBottom: marginBottom,
        backgroundColor: backgroundColor,
        borderBottom: `${borderBottomWidth} solid ${borderBottomColor}`,
        boxShadow: shadow ? "0 1px 2px rgba(0,0,0,0.08)" : "none",
        zIndex: 999,
      }}
    >
      {showLeftIcon ? (
        <div
          onClick={searchBtnOnClick}
          style={{
            paddingLeft: leftItemPaddingX,
            paddingRight: leftItemPaddingX,
            paddingTop: leftItemPaddingY,
            paddingBottom: leftItemPaddingY,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          aria-label="Arama"
        >
          {SearchIcon}
        </div>
      ) : (
        <div
          style={{
            paddingLeft: leftItemPaddingX,
            paddingRight: leftItemPaddingX,
            paddingTop: leftItemPaddingY,
            paddingBottom: leftItemPaddingY,
          }}
        />
      )}
      <img
        onClick={logoOnClick}
        src={logo}
        alt="Logo"
        style={{
          height: logoHeight,
        }}
      />

      {showRightIcon ? (
        <div
          onClick={notificationOnClick}
          style={{
            paddingLeft: rightItemPaddingX,
            paddingRight: rightItemPaddingX,
            paddingTop: rightItemPaddingY,
            paddingBottom: rightItemPaddingY,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          aria-label="Bildirimler"
        >
          {BellIcon}
        </div>
      ) : (
        <div
          style={{
            paddingLeft: rightItemPaddingX,
            paddingRight: rightItemPaddingX,
            paddingTop: rightItemPaddingY,
            paddingBottom: rightItemPaddingY,
          }}
        />
      )}
    </div>
  );
};
export default NavBar;
